import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';
import { APP_MANAGED_ROUTES } from 'common/constants';
import { RedirectSkeleton } from './loaders/redirect-skeleton.component';

export function HomeRedirect() {
  const navigate = useNavigate();

  navigate(APP_MANAGED_ROUTES.HOME, { replace: true });

  return <RedirectSkeleton />;
}
